module.exports = "/_next/static/images/row1-1-2x-ad847a70eea8bdb94194eba565f1caa3.png";